import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  Typography,
  DialogContent,
  Dialog,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { getSubscriptionBenefitsApi } from 'api/subscription';
import BenefitForm from './BenefitForm';
import BenefitsItem from './BenefitItem';


export default () => {
  const dispatch = useDispatch();
  const [selectedBenefit, setSelectedBenefit] = useState<ISubscriptionBenefitItem | undefined>();
  const { subscriptionBenefits } = useSelector((state: IReduxState) => state.subscription);
  const { annually, semiAnnually, monthly } = subscriptionBenefits;

  useEffect(() => {
    getSubscriptionBenefitsApi({ dispatch });
  }, []);

  return (
    <Accordion
      elevation={25}
      className="mb-4"
    >
      <AccordionSummary
        expandIcon={<Icon>expand_more</Icon>}
      >
        <Typography variant="h5" className="text-brand m-2" title="Benefits">Benefits</Typography>
      </AccordionSummary>
      <AccordionDetails className="block">
        <BenefitsItem
          title="Annually Benefits"
          benefitItems={annually}
          handleEdit={setSelectedBenefit}
        />
        <BenefitsItem
          title="Semi-Annually Benefits"
          benefitItems={semiAnnually}
          handleEdit={setSelectedBenefit}
        />
        <BenefitsItem
          title="Monthly Benefits"
          benefitItems={monthly}
          handleEdit={setSelectedBenefit}
        />


        <Button
          color="primary"
          variant="contained"
          onClick={() => setSelectedBenefit({ title: '', isEnabled: true, period: 'annually'})}
          className="m-4"
        >
          <Icon className="mr-2">add</Icon>
          <span>Add New Benefit</span>
        </Button>
        {selectedBenefit &&
        <Dialog
          open={Boolean(selectedBenefit)}
          onClose={() => setSelectedBenefit(undefined)}
          maxWidth={'md'}
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h4" className="mt-4">{selectedBenefit?._id ? 'Edit Benefit' : 'Create Benefit'}</Typography>
          </DialogTitle>
          <DialogContent  className="m-4">
            <BenefitForm item={selectedBenefit} setSelected={setSelectedBenefit} />
          </DialogContent>
        </Dialog>}
      </AccordionDetails>
    </Accordion>
  );
};
